import {
  Table,
  TableHeader,
  TableRow,
  Th,
  TableBody,
  Td,
  ExternalLink,
} from "@graffer-inc/console-design-kit";
import {
  ApplicationError,
  ErrorCodeForApplication,
} from "../../../../../application/domain/application/application-removal-task/create-task-result";
import { SmartApplyR } from "../../../../pages/smart-apply/route";
import { Link } from "react-router-dom";

type ApplicationsRegisterErrorProps = {
  applicationErrors: ApplicationError[];
};

const applicationErrorMessages: Record<
  ErrorCodeForApplication,
  (text: string) => React.ReactNode
> = {
  ApplicationNotFound: (_) => <>申請が見つかりません。</>,
  InvalidStatus: (_) => (
    <>
      申請のステータスが不正です。「完了」「差し戻し」「取り下げ」のいずれかのステータスの申請のみ削除できます。
    </>
  ),
  ApplicationRemovalScheduled: (existingTaskID) => (
    <>
      既に他の申請削除タスク(ID:
      <ExternalLink
        anchor={({ ...props }) => (
          <Link
            {...props}
            to={SmartApplyR.ApplicationRemovalTaskDetail.link({
              id: existingTaskID,
            })}
            className="p-0"
          >
            {existingTaskID}
          </Link>
        )}
      >
        {existingTaskID}
      </ExternalLink>
      )で、申請の削除が予定されています。
    </>
  ),
  ApplicationIsDuplicated: (_) => <>申請IDが重複しています。</>,
  HasUnhandledIssueRequest: (_) => (
    <>未対応の支払い明細書の交付依頼があります。</>
  ),
};

export const ApplicationsRegisterError: React.FC<
  ApplicationsRegisterErrorProps
> = ({ applicationErrors }) => {
  if (applicationErrors.length === 0) {
    return null;
  }

  return (
    <>
      <div className="notification is-danger is-light mb-2">
        以下の申請は削除できません。CSVを修正してアップロードし直してください。
      </div>
      <Table wrapper={false} borderType="row">
        <TableHeader>
          <TableRow>
            <Th>申請ID</Th>
            <Th>エラー内容</Th>
          </TableRow>
        </TableHeader>
        <TableBody>
          {applicationErrors.map((error) => (
            <TableRow key={error.applicationID}>
              <Td>{error.applicationID}</Td>
              <Td>
                {applicationErrorMessages[error.errorCode](error.errDetail)}
              </Td>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};
